import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getEmbedSettings } from '../state/selectors';
import { EmbedPartner } from '../enums/embed-partner';
import { PostMessage } from '../interfaces/post-message.interface';
import { PostMessageAction } from '../enums/post-message-action';
import { PostMessageParams } from '../interfaces/post-message-params.interface';

@Injectable({
  providedIn: 'root'
})
export class PostMessageService {
  private embedPartner: EmbedPartner | null = null;

  constructor(private store: Store) {
    this.store.pipe(select(getEmbedSettings)).subscribe(embedSettings => {
      if (embedSettings.partner) {
        this.embedPartner = embedSettings.partner;
      }
    });
  }

  getOrigin(): string {
    if (!this.embedPartner) {
      throw new Error('Could not get embed partner');
    }

    return this.getOriginForEmbedPartner(this.embedPartner);
  }

  getOriginForEmbedPartner(partner: EmbedPartner): string {
    if (partner === EmbedPartner.PROVET) {
      return 'https://awstest.provetcloud.com';
    }

    throw new Error('Could not get origin for embed partner')
  }

  buildMessagePayload(action: PostMessageAction, params?: PostMessageParams): PostMessage {
    return {
      service: "Digital Practice",
      action: action,
      params: params
   }
  }

  postMessage(action: PostMessageAction, params?: PostMessageParams): void {
    const payload = this.buildMessagePayload(action, params);
    const origin = this.getOrigin();
    console.log('SEND POST MESSAGE', payload, origin);
    if (window.parent) {
      window.parent.postMessage(payload, this.getOrigin());
    }
  }
}